import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useOutOfPocketMaxScheduleSteps from "./hooks/useOutOfPocketMaxScheduleSteps";

const OutOfPocketMaxScheduleSteps = () => {
  const outOfPocketMaxScheduleStepsData = useOutOfPocketMaxScheduleSteps();

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={outOfPocketMaxScheduleStepsData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {outOfPocketMaxScheduleStepsData.screen_title} -{" "}
          <span className="heading-cod">
            {outOfPocketMaxScheduleStepsData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={outOfPocketMaxScheduleStepsData.formFields}
        dropdownValues={outOfPocketMaxScheduleStepsData.dropdownValues}
        paramsData={outOfPocketMaxScheduleStepsData.paramsData}
        updataParamData={outOfPocketMaxScheduleStepsData.updateParamData}
      />
      <ButtonsSection ctaButtons={outOfPocketMaxScheduleStepsData.ctaButtons} />
      <DisplayTable
        data={outOfPocketMaxScheduleStepsData.data}
        parmKey={outOfPocketMaxScheduleStepsData.parmKey}
        menuOptions={outOfPocketMaxScheduleStepsData.menuOptions}
        tableHeaders={outOfPocketMaxScheduleStepsData.columnDef}
        setRowData={outOfPocketMaxScheduleStepsData.setRowData}
        selectedPriceSchedules={outOfPocketMaxScheduleStepsData.selectedRows}
        setSelectedPriceSchedules={
          outOfPocketMaxScheduleStepsData.setSelectedRows
        }
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={outOfPocketMaxScheduleStepsData.first}
          rows={outOfPocketMaxScheduleStepsData.rows}
          totalRecords={outOfPocketMaxScheduleStepsData.totalRecords}
          currentPage={outOfPocketMaxScheduleStepsData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={outOfPocketMaxScheduleStepsData.onPageChange}
        />
      </div>
      {outOfPocketMaxScheduleStepsData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={outOfPocketMaxScheduleStepsData.isConfirmationModalOpen}
          onRequestClose={
            outOfPocketMaxScheduleStepsData.closeConfirmationModal
          }
          onBack={outOfPocketMaxScheduleStepsData.closeConfirmationModal}
          onSave={outOfPocketMaxScheduleStepsData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={outOfPocketMaxScheduleStepsData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default OutOfPocketMaxScheduleSteps;
